module.exports = __webpack_public_path__ + "img/solution-image11.3a922e9b.png";